module.exports = __webpack_public_path__ + "img/icon-qr.453ed64a.jpg";